import { dateFNS } from '@gogame/intl-ts';

import { IS_FUTURE_COST_MODEL, CUSTOM_FLAT_FEE_ID } from './constants';

export const getCostModelDefaultEndDate = (type) => {
  if (type[IS_FUTURE_COST_MODEL]) {
    return dateFNS.addDays(dateFNS.endOfMonth(new Date()), 7);
  } else if (type.id === CUSTOM_FLAT_FEE_ID) {
    return dateFNS.startOfDay(new Date());
  }
};
